/**
 * Reaction Types Helper for SweldoNow
 * Maps to [dbo].[ReactionTypes]
 * For now, retrieve from this static data
 * Future updtes can include these data as part of global data 
 * that will be retrieved on login then will be saved in global UI cache
 */

export const REACTION_TYPES = [
    { id: 1, icon: 'thumb_up', color: '#1976D2', title: 'Like' },             // True Blue
    { id: 2, icon: 'favorite', color: '#E91E63', title: 'Love' },            // Vivid Pink/Red
    { id: 3, icon: 'rocket_launch', color: '#9C27B0', title: 'Awesome' },     // Purple
    { id: 4, icon: 'celebration', color: '#FF9800', title: 'Congrats' },     // Vibrant Orange
    { id: 5, icon: 'volunteer_activism', color: '#00E676', title: 'Thank You' }, // Bright Lime Green
    { id: 6, icon: 'check_circle', color: '#00B0FF', title: 'Noted' },        // Cyan/Sky Blue
    { id: 7, icon: 'task_alt', color: '#2E7D32', title: 'Acknowledged' },    // Dark Forest Green
    { id: 8, icon: 'lightbulb', color: '#FFD600', title: 'Insightful' },     // Bright Gold Yellow
    { id: 9, icon: 'handshake', color: '#00BCD4', title: 'Support' },       // Coral/Salmon
    { id: 10, icon: 'sentiment_dissatisfied', color: '#3F51B5', title: 'Sad' } // Indigo Blue
];

/**
 * Retrieves a reaction type object by its ID
 * @param {number|string} reactionTypeId 
 * @returns {object|null}
 */
export const getReactionType = (reactionTypeId) => {
    if (!reactionTypeId) return null;
    return REACTION_TYPES.find(r => r.id === parseInt(reactionTypeId)) || null;
};
